import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toggleDialog } from '../../../../../../store/actions/periodical-report.actions';
import { useDispatch, useSelector } from 'react-redux';
import IconTooltipButton from '../../../../../button/IconTooltipButton';
import ButtonSyncMarkingData from '../../SyncMarkngData/ButtonSyncMarkingData';
import GenerateXML from '../../GenerateXML/GenerateXML';

const ActionsButton = ({ formData, error, loading, isLoadingSave }) => {
  const { periodicalReportId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const permissions = useSelector(
    (state) => state?.session?.permissions?.['periodical-report-generator'] || {}
  );
  const permissionMarking = useSelector((state) => state?.session?.permissions?.['periodical-report-marking']);
  const onRedirect = (redirectTo) => {
    navigate(`/dashboard/periodical-report/${redirectTo}`);
  };

  if (loading || !formData) return <></>;
  return (
    <>
      {formData && formData?._id && (
        <>
          <ButtonSyncMarkingData loading={loading} periodicalReport={formData} />
          <GenerateXML loading={loading} periodicalReport={formData} />
          {['draft'].includes(formData.status) && permissions.deleted && (
            <IconTooltipButton
              id={`delete-${periodicalReportId}`}
              disabled={loading || isLoadingSave || error?.message}
              title='Delete'
              icon='trash-alt'
              style={{
                borderRadius: '0.5rem',
                backgroundColor: '#fff',
                color: 'var(--destructive)',
                padding: '0.45rem'
              }}
              className='shadow-sm'
              onClick={() => dispatch(toggleDialog('delete', formData))}
            />
          )}
          <div className='px-4' />
          {!formData.isCurrent && ['draft'].includes(formData.status) && permissions['set-as-current'] && (
            <IconTooltipButton
              id={`set-as-current-${periodicalReportId}`}
              disabled={loading || isLoadingSave || error?.message}
              title='Set as current'
              icon='star'
              color='secondary'
              style={{
                borderRadius: '0.5rem',
                color: 'var(--accent)',
                backgroundColor: 'var(--accent-foreground)',
                padding: '0.45rem'
              }}
              className='shadow-sm'
              onClick={() => dispatch(toggleDialog('set as current', formData))}
            />
          )}
          {permissionMarking && formData?.isGeneratedMarking && (
            <IconTooltipButton
              id={`marking-${formData._id}`}
              disabled={loading}
              title={['draft'].includes(formData.status) ? 'Preview Table' : 'Marking'}
              icon={['draft'].includes(formData.status) ? 'expand-alt' : 'pencil-mechanical'}
              style={{ 
                borderRadius: '0.5rem',
                color: 'var(--accent-foreground)',
                backgroundColor: 'var(--accent)',
                padding: '0.45rem'
              }}
              className='shadow-sm'
              onClick={() => onRedirect(`marking/${formData._id}`)}
            />
          )}
          {permissions.cloned && (
            <IconTooltipButton
              id={`clone-${periodicalReportId}`}
              disabled={loading || isLoadingSave || error?.message}
              title='Clone'
              icon='clone'
              color='secondary'
              style={{
                borderRadius: '0.5rem',
                color: 'var(--primary)',
                padding: '0.45rem'
              }}
              className='shadow-sm'
              onClick={() => dispatch(toggleDialog('clone', formData))}
            />
          )}
          <div className='px-1' />
        </>
      )}
    </>
  );
};

export default ActionsButton;
